import React from 'react';
import PropTypes from 'prop-types';
import css from './StyledLink.scss';
import { Link } from 'react-router-dom';

export default class StyledLink extends React.Component {
  render() {
    return (
      <Link className={`${css['link']} ${this.props.className}`} to={this.props.to}>{this.props.text}</Link>
    );
  }
}

StyledLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string
};
